// extracted by mini-css-extract-plugin
export default {"PageHeaderBrandNav":"PageHeader_PageHeaderBrandNav__eMOvB"};